<template>
  <div class="about-page" :class="{ 'is-en': isEn }">
    <site-header />
    <section class="page-banner" :style="{ backgroundImage: 'url(' + banner + ')' }"></section>
    <section class="intro">
      <div class="stage">
        <span class="name">{{ copy.about.name }}</span>
        <span class="name-blue">{{ copy.about.nameBlue }}</span>
        <div class="en-line">COMPANY INTRODUCE</div>
        <div class="intro-copy">
          <p v-for="(para, index) in copy.about.intro" :key="index">{{ para }}</p>
        </div>
      </div>
    </section>
    <section class="service">
      <div class="stage">
        <img class="photo left" :src="fileUrl('aboutUs/aboutUs_2.jpg')" :alt="copy.about.cultureTitle">
        <div class="culture">
          <h2>{{ copy.about.cultureTitle }}</h2>
          <div class="culture-en">COMPANY CULTRUE</div>
          <p v-for="(line, index) in copy.about.culture" :key="index">{{ line }}</p>
        </div>
        <div class="blue"></div>
        <img class="photo right" :src="fileUrl('aboutUs/aboutUs_1.jpg')" :alt="copy.about.tenetName">
        <span class="tenet-name">{{ copy.about.tenetName }}</span>
        <span class="tenet-blue">{{ copy.about.tenetBlue }}</span>
        <div class="tenet-en">SERVICE TENET</div>
        <div class="tenet-copy">
          <p v-for="(line, index) in copy.about.tenets" :key="index">{{ line }}</p>
        </div>
      </div>
    </section>
    <section class="stats">
      <div class="stage">
        <article v-for="item in cards" :key="item.no" class="card wow-down" :style="{ left: item.left }">
          <div class="no">{{ item.no }}</div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.text }}</p>
          <img :src="fileUrl(item.image)" :alt="item.title">
        </article>
      </div>
    </section>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import { fileUrl } from '@/utils/fileUrl'
import { getCopy } from '@/locale'

export default {
  name: 'AboutPage',
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      banner: fileUrl('aboutUs/aboutBanner.png')
    }
  },
  computed: {
    /** 是否英文站 */
    isEn() {
      return this.$route.meta && this.$route.meta.lang === 'en'
    },
    /** 按路由语言取关于我们文案 */
    copy() {
      return getCopy(this.isEn ? 'en' : 'zh')
    },
    /** 三张能力卡片 */
    cards() {
      const a = this.copy.about
      return [
        { no: '01', title: a.card1Title, text: a.card1Text, image: 'aboutUs/展示-02.jpg', left: '4%' },
        { no: '02', title: a.card2Title, text: a.card2Text, image: 'aboutUs/展示-03.jpg', left: '36%' },
        { no: '03', title: a.card3Title, text: a.card3Text, image: 'aboutUs/合作伙伴.jpg', left: '68%' }
      ]
    }
  },
  mounted() {
    this.bindScrollAnim()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    /** 拼接文件服务器上的图片地址 */
    fileUrl(path) {
      return fileUrl(path)
    },
    /** 三张服务卡片滚进视口后从上往下滑入 */
    bindScrollAnim() {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in')
            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0 })
      this.observer = observer
      const nodes = this.$el.querySelectorAll('.wow-down')
      nodes.forEach(function (node) {
        observer.observe(node)
      })
    }
  }
}
</script>

<style scoped>
.about-page {
  background: #fff;
  color: #333;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}
.page-banner {
  height: 500px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}
.stage {
  position: relative;
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
}
.intro { height: 341px; }
.name,
.name-blue {
  position: absolute;
  top: 55px;
  z-index: 2;
  font-size: 30px;
  line-height: 50px;
  letter-spacing: 2px;
  background: #fff;
  white-space: nowrap;
}
.name {
  left: 43.166667%;
  width: 16.25%;
  text-align: right;
}
.name-blue {
  left: 59.416667%;
  width: 5.416667%;
  color: #3db7ef;
  font-weight: bold;
}
.en-line {
  position: absolute;
  top: 83px;
  left: 30.291667%;
  width: 47.5%;
  border-top: 1px dashed #3db7ef;
  line-height: 90px;
  font-size: 22px;
  font-weight: bold;
  font-family: Tahoma, sans-serif;
  color: #e5e5e5;
  text-align: center;
}
.intro-copy {
  position: absolute;
  top: 166px;
  left: 0;
  width: 100%;
  font-size: 16px;
  line-height: 35px;
  color: #a2a2a2;
}
.intro-copy p {
  margin: 0;
  text-indent: 2em;
}
.service { height: 756px; }
.photo {
  position: absolute;
  width: 50%;
  height: 400px;
  object-fit: fill;
}
.photo.left { top: 26px; left: 0; }
.photo.right { top: 355.5px; left: 50%; }
.blue {
  position: absolute;
  top: 426px;
  left: 0;
  width: 50%;
  height: 330px;
  background: #3db7ef;
}
.culture h2,
.culture-en,
.culture p {
  position: absolute;
  left: 7%;
  margin: 0;
}
.culture h2 {
  top: 481.5px;
  z-index: 3;
  width: 36.666667%;
  color: #fff;
  font-size: 30px;
  font-weight: bold;
  line-height: 50px;
}
.culture-en {
  top: 543.5px;
  z-index: 2;
  width: 35.083333%;
  font-family: Verdana, sans-serif;
  font-size: 22px;
  font-weight: bold;
  line-height: 30px;
  color: #e5e5e5;
}
.culture p {
  z-index: 4;
  width: 35.333333%;
  color: #fff;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: 2px;
  text-align: justify;
}
.culture p:nth-child(3) { top: 600.5px; }
.culture p:nth-child(4) { top: 625.5px; }
.culture p:nth-child(5) { top: 650.5px; }
.culture p:nth-child(6) { top: 675.5px; }
.tenet-name,
.tenet-blue {
  position: absolute;
  top: 69px;
  font-size: 30px;
  line-height: 50px;
  white-space: nowrap;
}
.tenet-name { left: 58.666667%; width: 6.666667%; }
.tenet-blue {
  left: 63.833333%;
  width: 13.666667%;
  color: #3db7ef;
  font-weight: bold;
}
.tenet-en {
  position: absolute;
  top: 122px;
  left: 58.666667%;
  width: 22.666667%;
  font-family: Verdana, sans-serif;
  font-size: 22px;
  font-weight: bold;
  line-height: 50px;
  color: #ededed;
}
.tenet-copy {
  position: absolute;
  top: 177px;
  left: 58.666667%;
  width: 41.333333%;
  font-size: 16px;
  line-height: 35px;
  color: #a2a2a2;
}
.tenet-copy p { margin: 0; }
.stats {
  height: 560px;
  margin-top: 50px;
}
.card {
  position: absolute;
  top: 4px;
  width: 28%;
  height: 495px;
  box-shadow: 5px 5px 9px #999;
  opacity: 0;
}
/* 英文站定位对齐官网 aboutUs_EN.html */
.about-page.is-en .intro { height: 495px; }
.about-page.is-en .name,
.about-page.is-en .name-blue {
  font-size: 26px;
  letter-spacing: 0;
  overflow: hidden;
}
.about-page.is-en .name {
  left: 24.25%;
  width: 34.583333%;
}
.about-page.is-en .name-blue {
  left: 58.833333%;
  width: 17.833333%;
}
.about-page.is-en .en-line {
  left: 13.791667%;
  width: 75%;
}
.about-page.is-en .service { height: 834px; }
.about-page.is-en .photo.right { top: 429.5px; height: 399px; }
.about-page.is-en .blue { height: 403px; }
.about-page.is-en .culture h2,
.about-page.is-en .culture-en,
.about-page.is-en .culture p {
  left: 3.833333%;
}
.about-page.is-en .culture p {
  width: 45.166667%;
  letter-spacing: 0;
}
.about-page.is-en .tenet-name {
  width: 10.5%;
}
.about-page.is-en .tenet-blue {
  left: 69.5%;
  width: 10.25%;
}
.about-page.is-en .stats { height: 621px; }
.about-page.is-en .card { height: 570px; }
.about-page.is-en .card img { top: 340px; }
.card.is-in {
  opacity: 1;
  animation: aboutSlideInDown 1s 0.25s both;
}
.card .no {
  position: absolute;
  top: 50px;
  left: 10%;
  width: 85%;
  margin: 0;
  font-size: 68px;
  line-height: 75px;
  font-weight: normal;
}
.card h3 {
  position: absolute;
  top: 150px;
  left: 10%;
  width: 80%;
  margin: 0;
  font-size: 18px;
  line-height: 25px;
  font-weight: normal;
}
.card p {
  position: absolute;
  top: 200px;
  left: 10%;
  width: 80%;
  margin: 0;
  font-size: 16px;
  line-height: 1.8;
}
.card img {
  position: absolute;
  top: 275px;
  left: 10%;
  width: 80%;
  height: 170px;
  object-fit: fill;
}
@keyframes aboutSlideInDown {
  from { transform: translate3d(0, -100%, 0); }
  to { transform: translate3d(0, 0, 0); }
}
@media (min-width: 641px) and (max-width: 1200px) {
  .page-banner { height: 350px; }
}
@media (max-width: 640px) {
  .page-banner { height: 250px; }
  .intro,
  .service,
  .stats { height: auto; }
  .stats { margin-top: 13px; }
  .stage { height: auto; padding: 24px 16px; }
  .name,
  .name-blue,
  .en-line,
  .intro-copy,
  .photo,
  .blue,
  .culture h2,
  .culture-en,
  .culture p,
  .tenet-name,
  .tenet-blue,
  .tenet-en,
  .tenet-copy,
  .card,
  .card .no,
  .card h3,
  .card p,
  .card img {
    position: static;
    width: auto;
    left: auto;
    top: auto;
    height: auto;
  }
  .photo { display: block; width: 100%; height: 220px; margin-bottom: 16px; }
  .blue { display: none; }
  .culture p:nth-child(n) { position: static; }
  .card { margin-bottom: 24px; opacity: 1; }
  .card img { display: block; width: 100%; height: 160px; margin-top: 12px; }
}
</style>
